import { Modelo } from '@ext/index';
import * as Types from './Turnero.types';
import moment, { Moment } from 'moment';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import { Utiles } from '@/__env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { Recurso } from '@/__env/lib/Turnero/Recursos/Recurso.nav';
import { isArray } from 'util';
import { publicDecrypt } from 'crypto';

export class ITurnero extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Inicial: number = 0;
    public Actual: number = 0;
    public Final: number = 0;
    public Puestos: number = 0;
    public Mensajes: string[] = [];

    public Llamados: Llamado[] = [];
    public Recursos: Recurso[] = [];

    public getJson(): any
    {
        let json: any = {};
        json.mensajes = this.Mensajes;
        json.recursos = this.Recursos.map( x => x.getJson() );
        return json;
    }

    public set(): boolean
    {

        this.Id = this.Json.id;
        this.Inicial = this.Json.numero_inicial;
        this.Actual = this.Json.numero_actual;
        this.Final = this.Json.numero_final;
        this.Puestos = this.Json.cantidad_puestos;


        if ( isArray( this.Json.llamados ) )
        {
            this.Llamados = this.Json.llamados.map( ( x: any ) => new Llamado( x ) );
        }

        this.Mensajes.clear();
        if ( isArray( this.Json.mensajes ) )
        {
            this.Mensajes = this.Json.mensajes.map( ( x: any ) => String( x ) );
        }

        this.Recursos.clear();
        if ( isArray( this.Json.recursos ) )
        {

            for ( let e of this.Json.recursos )
            {
                this.Recursos.add( new Recurso( e ) );
            }
        }

        if ( !this.SocketIniciado )
            this.IniciarSocket();

        this.Existe = true;
        return this.Existe;
    }

    protected SocketIniciado: boolean = false;
    protected IniciarSocket()
    {
        Utiles.$socket.client.on( `turnero-${this.Id}-numero`, ( x: any ) =>
        {
            this.Actualizar( x );
            this._onUltimoLlamado.dispatch();
        } );

        Utiles.$socket.client.on( `turnero-${this.Id}-reiniciar`, () =>
        {
            this.ReiniciarContador();
        } );

        Utiles.$socket.client.on( `turnero-${this.Id}-volver`, () =>
        {
            this._onRellamar.dispatch();
        } );
        this.SocketIniciado = true;
    }

    public Actualizar( x: any )
    {
        this.Actual = x.numero;
        this.Llamados.unshift( new Llamado( x ) );
        while ( this.Llamados.length > 5 )
        {
            this.Llamados.pop();
        }
        this._onActualizar.dispatch();
    }

    public ReiniciarContador()
    {
        this.Actual = 0;
        this.Llamados.clear();
        this._onActualizar.dispatch();
    }

    private _onUltimoLlamado = new SignalDispatcher();
    public get onUltimoLlamado() { return this._onUltimoLlamado.asEvent(); }

    private _onRellamar= new SignalDispatcher();
    public get onRellamar() { return this._onRellamar.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: ITurnero )
    {
        this.Model = Model;
    }

    public Model: ITurnero;
}


export class Llamado extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Numero: number;
    public Puesto: number;
    public Fecha: Moment;

    public set(): boolean
    {
        this.Numero = this.Json.numero;
        this.Puesto = this.Json.puesto;
        this.Fecha = moment( this.Json.fecha );

        this.Existe = true;
        return this.Existe;
    }
}